export default "__VITE_ASSET__bbEIuvdQ__"